<template>
  <div id="app" :class="{fon:!changeFon, fonAlternative:changeFon}">
    <div v-if="show_nav" class="container-fluid header-bg">
      <div class="container" style="padding:14px 0;">
        <!-- <div class="changeFon" @click="pasha1()"></div> -->
        <div class="row " data-intro="#top-menu">
          <div class="col text-center"><a href="https://warforgalaxy.com/" class="header_a">Главная</a></div>
          <div class="col text-center"><a href="https://forum.warforgalaxy.com/" class="header_a">Форум</a></div>
          <div class="col text-center"><a href="https://warforgalaxy.com/play/" class="header_a">Играть сейчас</a></div>
          <div class="col text-center"><a href="https://warforgalaxy.com/store" class="header_a">Магазин</a></div>
          <div v-if="this.token" class="col text-center"><a href="https://warforgalaxy.com/logout" class="header_a">Выход</a></div>
        </div>
      </div>
    </div>
    <div class="butnav" @click="open_nav()">
      <img v-if="!show_nav" src="@/assets/img/downnav1.png" alt="">
      <img v-if="show_nav" src="@/assets/img/upnav1.png" alt="">
    </div>

    <div :class="{mask:1,  martop:show_nav}">
    </div>
    <!-- <MenuComponent v-if="this.$route.name != 'Login'" /> -->
    <div :class="{container_messeger:1, 'position-relative':1, heigth_messeger:show_nav, 'mx-auto':1}">
      <keep-alive :max="5" include="Planets">
        <router-view v-if="isDone" :key="$route.fullPath"/>
      </keep-alive>
    </div>
    <!-- <AlertComponent ref="AlertComponent"></AlertComponent> -->
    <notifications position="bottom right" />

    <!-- <button class="toggle-help" @click="toggleHelper">Старт</button> -->

    <div class="app-preloader" v-if="!isDone">
      <div class="loading" ref="loadingtext">{{ loadingText }}</div>
    </div>

    <div class="theme-toggler" @click="toggleThemeMode">
      <svg id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m424.216 424.216h15v15.001h-15z" transform="matrix(.711 -.703 .703 .711 -178.814 428.484)"/><path d="m437.02 74.98c-48.352-48.351-112.64-74.98-181.02-74.98s-132.668 26.629-181.02 74.98c-48.351 48.353-74.98 112.64-74.98 181.02s26.629 132.667 74.98 181.02c48.352 48.351 112.64 74.98 181.02 74.98 59.793 0 117.978-21.06 163.835-59.299l-9.607-11.521c-43.165 35.996-97.938 55.82-154.228 55.82-64.374 0-124.894-25.068-170.413-70.587s-70.587-106.039-70.587-170.413 25.068-124.894 70.587-170.413 106.039-70.587 170.413-70.587 124.894 25.068 170.413 70.587 70.587 106.039 70.587 170.413c0 56.315-19.843 111.11-55.874 154.292l11.518 9.61c38.276-45.873 59.356-104.082 59.356-163.902 0-68.38-26.629-132.667-74.98-181.02z"/><path d="m327.25 353.5c53.762 0 97.5-43.738 97.5-97.5s-43.738-97.5-97.5-97.5c-15.7 0-31.168 3.788-45 10.989-13.832-7.201-29.3-10.989-45-10.989-22.882 0-45.125 8.091-62.632 22.782l9.643 11.49c14.81-12.428 33.629-19.272 52.989-19.272 10.313 0 20.503 1.929 30.018 5.64-23.419 18.334-37.518 46.715-37.518 76.86s14.1 58.526 37.518 76.86c-9.515 3.71-19.705 5.64-30.018 5.64-45.49 0-82.5-37.009-82.5-82.5 0-19.493 6.929-38.411 19.51-53.271l-11.447-9.692c-14.873 17.565-23.063 39.925-23.063 62.963 0 53.762 43.738 97.5 97.5 97.5 15.7 0 31.168-3.788 45-10.989 13.832 7.201 29.3 10.989 45 10.989zm-82.5-97.5c0-29.36 15.809-56.744 41.256-71.465 12.479-7.219 26.741-11.035 41.244-11.035 45.49 0 82.5 37.009 82.5 82.5s-37.01 82.5-82.5 82.5c-14.503 0-28.766-3.816-41.244-11.036-25.447-14.72-41.256-42.104-41.256-71.464z"/><path d="m229.75 368.5h15v30h-15z"/><path d="m158.5 358.918h30v15h-30z" transform="matrix(.5 -.866 .866 .5 -230.577 333.466)"/><path d="m229.75 113.5h15v30h-15z"/><path d="m111.832 312.25h30v15h-30z" transform="matrix(.866 -.5 .5 .866 -142.884 106.256)"/><path d="m166 130.582h15v30h-15z" transform="matrix(.866 -.5 .5 .866 -49.547 106.255)"/><path d="m94.75 248.5h30v15h-30z"/><path d="m119.332 177.25h15v30h-15z" transform="matrix(.5 -.866 .866 .5 -103.077 205.964)"/><path d="m368.498 67.5h15v15h-15z"/><path d="m338.499 52.5h15v15h-15z"/></g></svg>
    </div>
  </div>
</template>

<script type="text/javascript">
// import MenuComponent from '@/components/MenuComponent.vue'
// import AlertComponent from '@/components/basic_component/AlertComponent.vue'
import config from './config'
// import store from './store'
import { loop } from './helpers'
import '@/assets/css/main.css'
import nameUnits from '@/libs/nameunits'

const isLocal = document.location.href.indexOf("localhost") > -1
const isDev = document.location.host === 'gmdev.warforgalaxy.com'
const returnTo = isDev ? config.ccDevBaseURL : config.ccBaseURL

export default {
  name: 'App',
  async created() {
    this.show_nav = false
    this.changeFon = localStorage.getItem("changeFon") == "true"

    this.initCurrentTheme()

    let token = isLocal ? config.devToken : this.getCookie("glxtoken")
    if (!token) {
      return this.goToAuthServer()
    }

    try {
      this.setLoadingText(`Авторизация`)
      let isValidToken = await this.checkAuth(token)

      if (isValidToken === null) {
        this.setLoadingText(`Авторизация. Вторая попытка`)
        await this.wait(1500)
        isValidToken = await this.checkAuth(token)
      }

      if (isValidToken === false) {
        return this.goToAuthServer()
      }
    } catch (err) {
      console.log(err)
      return this.goToAuthServer()
    }

    this.token = token
    //console.log(store())
    this.$store.commit('setToken', token)
    this.initAxiosInterceptor(token)

    // Проверка того что выбранная (сохраненная планета) есть в списке планет пользователь
    // т.к. иначе при смене аккаунта фризились фукнции
    // try {
    //   const selectedPlanet = JSON.parse(window.localStorage.getItem('selectPlanet'))
    //   const checkingResult = await this.selectedPlanetExists(selectedPlanet.id)
    //   if (!checkingResult) {
    //     throw new Error('Selected planet doesnt exist')
    //   }
    // } catch (err) {
    //   console.log(err)
    //   window.localStorage.removeItem('selectPlanet')
    // }

    // this.chardinIns = window.$('body').chardinJs({
    //   url: "/helper/ru.json"
    // })

    // window.$(document).on('click', '.chardin-overlay-prev', (ev) => {
    //   ev.preventDefault()

    //   this.chardinIns.previous(false)
    //   return false
    // })

    // window.$(document).on('click', '.chardin-overlay-next', (ev) => {
    //   ev.preventDefault()

    //   this.chardinIns.next(false)
    //   return false
    // })

    
    //this._checkLicense()

    try {
      this.setLoadingText(`Подгрузка технологий и флотов`)
      await this._updateFleetsAndTechs()
      this.setLoadingText(`Проверка лицензии`)
      await this._checkLicense()
    } catch (err) {
      this.$refs.loadingtext.classList.remove('loading')
      return this.setLoadingText(`Техническая ошибка. Попробуйте перезагрузить страницу позднее.`)
    }

    loop(async () => {
      await this._updateFleetsAndTechs()
      await this._checkLicense()
    }, 120000)

    setTimeout(() => this.isDone = true, 500)

    this.setLoadingText(`Кэширование изображений`)
    this.loadReportImages(nameUnits)
  },
  data (){
    return{
      token: false,
      show_nav: false,
      changeFon: false,
      chardinIns: null,
      licenseInfo: null,
      isDone: false,
      loadingText: 'Загрузка'
    }
  },
  computed: {
    isAuth() { return !!this.token },
  },
  methods:{
    setLoadingText(text) {
      this.loadingText = text
    },
    initCurrentTheme() {
      const curTheme = localStorage.getItem('glxtheme')
      if (curTheme === 'light') {
        this._setBodyDataTheme('light')
      } else {
        this._setBodyDataTheme('dark')
      }
      //this._setBodyDataTheme('light')
    },
    _setBodyDataTheme(theme) {
      try {
        document.querySelector('body').dataset.theme = theme
      } catch (err) {
        console.log(err)
      }
    },
    toggleThemeMode() {
      const body = document.querySelector('body')
      const curTheme = body.dataset.theme
      let nextTheme = 'light'
      
      if (curTheme === 'light') {
        nextTheme = 'dark'
      }

      body.dataset.theme = nextTheme
      localStorage.setItem('glxtheme', nextTheme)
    },
    async _updateFleetsAndTechs() {
      this.$store.commit('setFleets', await this.getFleets())
      this.$store.commit('setTechs', await this.getTechs())
    },
    async _checkLicense() {
      try {
        const licenseInfo = await this.loadLicenseInfo(this.token)
        this.$store.commit('setLicense', licenseInfo)
      } catch (err) {
        this.$notify({ type: "error", text: err.toString() })
      }
    },
    async selectedPlanetExists(selectedPlanetId) {
      const { data: json } = await this.$axios.get(`/user/planets`)

      for (let p of json.items) if (selectedPlanetId === p.id) {
        return true
      }

      return false
    },
    pasha1(){
      this.changeFon = !this.changeFon
      localStorage.setItem("changeFon", this.changeFon)
    },
    open_nav(){
      this.show_nav = !this.show_nav
      localStorage.setItem("show_nav", this.show_nav)
    },
    getCookie(name) {
      let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    toggleHelper() {
      this.chardinIns.initSeq();
      (window.$('body').data('chardinJs')).toggle();
    },
    async loadLicenseInfo(token) {
      const { data: json } = await this.$axios.post('https://api.warforgalaxy.com/user/checkcc', { token })

      if (json.status !== 1) {
        throw new Error('Не удалось загрузить информацию о текущей подписке')
      }

      return json.data
    },
    goToAuthServer() {
      if (isLocal) return;

      return document.location.href = `https://warforgalaxy.com/login?return=${returnTo}`
    },
    async checkAuth(token) {
      let status
      try {
        const response = await this.$axios.post(`app/enter`, null, { headers: { token }, timeout: config.authTimeout })
        status = response.status
      } catch (err) {
        return null
      }
      
      return status === 200
    },
    wait(ms) {
      return new Promise(resolver => setTimeout(resolver, ms))
    },
    initAxiosInterceptor(token) {
      this.$axios.defaults.headers.common['token'] = token
      this.$axios.interceptors.response.use(
        response => response,
        error => {
          if (!error.response) {
            this.$notify({
              title: 'Ошибка',
              text: 'Сервер вернул неправильный ответ, попробуйте перезагрузить страницу',
              type: 'error ',
            })
          }

          let status = null

          try {
            status = error.response.status
          } catch (err) {
            return Promise.reject(new Error(`Не удалось произвести запрос`))
          }

          if (status === 401 && !isDev) {
            return document.location.href = `https://warforgalaxy.com/login?return=${returnTo}`
          } else {
            return Promise.reject(error)
          }
          // } else if (status !== 402) {
          //   this.$notify({
          //     title: 'Ошибка',
          //     text: 'Сервер вернул неправильный ответ('+status+'), попробуйте перезагрузить страницу',
          //     type: 'error ',
          //   })
          // } else {
          //   return Promise.reject(error);
          // }

      })
    },
    async getFleets() {
      const { data: json } = await this.$axios.get(`/user/fleets`)
      return json
    },
    async getTechs() {
      const { data: json } = await this.$axios.get(`/user/technologies`)
      return json
    },
    async loadReportImages(nameUnitsObj) {
      return new Promise(resolver => {
        for (let k in nameUnitsObj) {
          try {
            const image = new Image()
            image.src = `/img/report/${k}.jpg`
          } catch (err) {
            console.log(err)
          }
        }

        resolver()
      })
    }
  },
}

</script>

<style media="screen">
.butLine{
  transform: translate(-50%, 0);
  left: 50%;
}
.butnav{
  border-radius: 1px;
  z-index: 800;
  cursor: pointer;
  width: 30px;
  right: 0;
  text-align: center;
  position: absolute;
  padding: 5px;
  background: var(--app-butnav-bg);
}
.fonAlternative{
  background: url(/img/fon2.jpg);
  background-size: auto;
  background-position: center;
  background-attachment: fixed, fixed;

}
.changeFon{
  z-index: 99999;
  /* cursor: pointer; */
  width: 15px;
  height: 15px;
  position: absolute;
  left: 0;
  top: 0;
}
.butnav>img{
  height: 15px;
  width: 15px;
}
.header-bg{
  font-size: 14px;
  color: var(--app-header-bg-color);
  background: url('/img/header_bg.66fc8933.png');
  z-index: 99999;
}
.header_a:hover{
  color: var(--app-header-a-hover-color);
}
.maincolor{
  color: var(--app-maincolor-color);
}
.martop{
  margin-top: 49px;
}
.mask{
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: var(--app-mask-bg);
  position: fixed;
}
.fon{
  background: url(/img/wallhave3.webp);
  background-size: cover;
  background-position: center;
  background-attachment: fixed, fixed;


}
.heigth_messeger{
  height: calc(100vh - 50px)!important;
}
.container_messeger{
  overflow: hidden;
  width: 100%;
  max-width: 1390px;
  height: 100vh;

}
a{
  color: inherit;
}
a:hover{
  text-decoration: none;
  color: inherit;
}
.n{font-weight: normal;}
.m{font-weight: 500;}
.b{font-weight: 700;}

#squaresWaveG{
  background: #f4f4f4;
	position:relative;
	display: flex;
	width:100%;
	margin:auto;
	/* margin-top: 10px; */
}

.squaresWaveG{
	/* position:absolute; */
	top:0;
	background-color:rgb(#f4f4f4);
	width: 100%;
	height:4px;
	animation-name:bounce_squaresWaveG;
		-o-animation-name:bounce_squaresWaveG;
		-ms-animation-name:bounce_squaresWaveG;
		-webkit-animation-name:bounce_squaresWaveG;
		-moz-animation-name:bounce_squaresWaveG;
	animation-duration:0.5s;
		-o-animation-duration:0.5s;
		-ms-animation-duration:0.5s;
		-webkit-animation-duration:0.5s;
		-moz-animation-duration:0.5s;
	animation-iteration-count:infinite;
		-o-animation-iteration-count:infinite;
		-ms-animation-iteration-count:infinite;
		-webkit-animation-iteration-count:infinite;
		-moz-animation-iteration-count:infinite;
	animation-direction:alternate-reverse;
		-o-animation-direction:alternate-reverse;
		-ms-animation-direction:alternate-reverse;
		-webkit-animation-direction:alternate-reverse;
		-moz-animation-direction:alternate-reverse;
}

#squaresWaveG_1{
	animation-delay:0.1s;
		-o-animation-delay:0.1s;
		-ms-animation-delay:0.1s;
		-webkit-animation-delay:0.1s;
		-moz-animation-delay:0.1s;
}

#squaresWaveG_2{
	animation-delay:0.2s;
		-o-animation-delay:0.2s;
		-ms-animation-delay:0.2s;
		-webkit-animation-delay:0.2s;
		-moz-animation-delay:0.2s;
}

#squaresWaveG_3{
	animation-delay:0.3s;
		-o-animation-delay:0.3s;
		-ms-animation-delay:0.3s;
		-webkit-animation-delay:0.3s;
		-moz-animation-delay:0.3s;
}

#squaresWaveG_4{
	animation-delay:0.4s;
		-o-animation-delay:0.4s;
		-ms-animation-delay:0.4s;
		-webkit-animation-delay:0.4s;
		-moz-animation-delay:0.4s;
}

#squaresWaveG_5{
	animation-delay:0.5s;
		-o-animation-delay:0.5s;
		-ms-animation-delay:0.5s;
		-webkit-animation-delay:0.5s;
		-moz-animation-delay:0.5s;
}

#squaresWaveG_6{
	animation-delay:0.6s;
		-o-animation-delay:0.6s;
		-ms-animation-delay:0.6s;
		-webkit-animation-delay:0.6s;
		-moz-animation-delay:0.6s;
}

#squaresWaveG_7{
	animation-delay:0.7s;
		-o-animation-delay:0.7s;
		-ms-animation-delay:0.7s;
		-webkit-animation-delay:0.7s;
		-moz-animation-delay:0.7s;
}

#squaresWaveG_8{
	animation-delay:0.8s;
		-o-animation-delay:0.8s;
		-ms-animation-delay:0.8s;
		-webkit-animation-delay:0.8s;
		-moz-animation-delay:0.8s;
}



@keyframes bounce_squaresWaveG{
	0%{
		background-color:#ff8100;
	}

	100%{
		background-color:rgb(255,255,255);
	}
}

@-o-keyframes bounce_squaresWaveG{
	0%{
		background-color:#ff8100;
	}

	100%{
		background-color:rgb(255,255,255);
	}
}

@-ms-keyframes bounce_squaresWaveG{
	0%{
		background-color:#ff8100;
	}

	100%{
		background-color:rgb(255,255,255);
	}
}

@-webkit-keyframes bounce_squaresWaveG{
	0%{
		background-color:#ff8100;
	}

	100%{
		background-color:rgb(255,255,255);
	}
}

@-moz-keyframes bounce_squaresWaveG{
	0%{
		background-color:#ff8100;
	}

	100%{
		background-color:rgb(255,255,255);
	}
}
::-webkit-scrollbar {  width: 10px; height: 10px;}

::-webkit-scrollbar-track-piece { background-color: var(--app-scrollbar-piece-bg-color);}
::-webkit-scrollbar-thumb {  background-color: var(--app-scrollbar-thumb-bg-color);}

::-webkit-scrollbar-corner { background-color: var(--app-scrollbar-corner-bg-color);}
::-webkit-resizer { background-color: var(--app-resizer-bg-color);}

.toggle-help {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.app-preloader {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: var(--app-preloader-bg);
  z-index: 999;
  color: var(--app-preloader-color);
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading:after {
  content: ' .';
  animation: dots 1s steps(5, end) infinite;}

@keyframes dots {
  0%, 20% {
    color: rgba(0,0,0,0);
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  40% {
    color: white;
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  60% {
    text-shadow:
      .25em 0 0 white,
      .5em 0 0 rgba(0,0,0,0);}
  80%, 100% {
    text-shadow:
      .25em 0 0 white,
      .5em 0 0 white;}}


.theme-toggler {
  background: var(--app-theme-toggler-bg);
  width: 60px;
  height: 60px;
  position: fixed;
  bottom: 10px;
  left: 10px;
  border-radius: 50%;
  padding: 5px;
  z-index: 99;
  cursor: pointer;
}

.theme-toggler svg {
  width: 50px;
  height: 50px;
}

.theme-toggler svg path {
  fill: var(--app-theme-toggler-svg-path-fill);
}
</style>
